import { atom } from 'recoil';

export const groupingState = atom({
  key: 'groupingState', // unique ID (with respect to other atoms/selectors)
  default: {
    grouping: 'Day',
  }, // default value (aka initial value)
});
